const HEADER_HEIGHT = 72;

module.exports = {
  HEADER_HEIGHT,
};
